import { StorageService } from '../../auth/services/storage.service';
import { AuthService } from '../../auth/services/auth.service';

export abstract class BaseApiService {
  protected static getAuthHeaders(): HeadersInit {
    const accessToken = StorageService.getAccessToken();
    if (!accessToken) {
      throw new Error('No access token available');
    }

    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    };
  }

  protected static handleAuthError(response: Response): void {
    if (response.status === 401) {
      AuthService.logout();
      // Redirigir al login
      if (typeof window !== 'undefined') {
        window.location.href = '/auth/login';
      }
    }
  }

  protected static async handleResponse<T>(response: Response): Promise<T> {
    if (!response.ok) {
      this.handleAuthError(response);
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Request failed with status ${response.status}`);
    }

    return response.json();
  }

  protected static async handleResponseWithoutData(response: Response): Promise<void> {
    if (!response.ok) {
      this.handleAuthError(response);
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Request failed with status ${response.status}`);
    }
  }
}
